import { render, staticRenderFns } from "./OrderSubmitPage.vue?vue&type=template&id=57462c5c&scoped=true&"
import script from "./OrderSubmitPage.vue?vue&type=script&lang=js&"
export * from "./OrderSubmitPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57462c5c",
  null
  
)

export default component.exports